export default __webpack_public_path__ + "static/media/signum-es.d32fe91f.png";